/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_attributes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_inspector__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_get_style__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_scss__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * External Dependencies
 */



/**
 * WordPress Dependencies
 */
var addFilter = wp.hooks.addFilter;
var getWrapperDisplayName = wp.element.getWrapperDisplayName;

/**
 * Internal Dependencies
*/






/**
 * Filters registered block settings, extending attributes with background settings
 *
 * @param {Object} settings Original block settings.
 * @return {Object} Filtered block settings.
 */
function addAttribute(settings) {
  // Use Lodash's assign to gracefully handle if attributes are undefined
  settings.attributes = __WEBPACK_IMPORTED_MODULE_0_lodash_assign___default()(settings.attributes, __WEBPACK_IMPORTED_MODULE_2__data_attributes__["a" /* default */]);
  return settings;
}

/**
 * Override the default edit UI to include a new block inspector control for
 * background settings.
 *
 * @param {function|Component} BlockEdit Original component.
 * @return {string} Wrapped component.
 */
function withInspectorControl(BlockEdit) {
  var WrappedBlockEdit = function WrappedBlockEdit(props) {
    return [props.isSelected && wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3__components_inspector__["a" /* default */], _extends({}, props)), wp.element.createElement(BlockEdit, _extends({ key: 'block-edit-background' }, props))];
  };
  WrappedBlockEdit.displayName = getWrapperDisplayName(BlockEdit, 'block-background');

  return WrappedBlockEdit;
}

/**
 * Override the default block element to add background wrapper props.
 *
 * @param  {Function} BlockListBlock Original component
 * @return {Function}                Wrapped component
 */
function withBackground(BlockListBlock) {
  var WrappedComponent = function WrappedComponent(props) {
    var wrapperProps = props.wrapperProps;
    wrapperProps = _extends({}, wrapperProps, {
      style: Object(__WEBPACK_IMPORTED_MODULE_4__utils_get_style__["a" /* default */])(props.block.attributes)
    });

    return wp.element.createElement(BlockListBlock, _extends({}, props, { wrapperProps: wrapperProps }));
  };

  WrappedComponent.displayName = getWrapperDisplayName(BlockListBlock, 'block-background');

  return WrappedComponent;
}

/**
 * Override props assigned to save component to inject background atttributes
 *
 * @param {Object} extraProps Additional props applied to save element.
 * @param {Object} blockType  Block type.
 * @param {Object} attributes Current block attributes.
 *
 * @return {Object} Filtered props applied to save element.
 */
function addBackground(extraProps, blockType, attributes) {
  extraProps.style = Object(__WEBPACK_IMPORTED_MODULE_4__utils_get_style__["a" /* default */])(attributes);
  var backgroundType = attributes.backgroundType,
      solidColor = attributes.solidColor,
      gradient = attributes.gradient,
      imageID = attributes.imageID;


  if (backgroundType && (solidColor || gradient || imageID)) {
    extraProps.className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(extraProps.className, 'has-background');
  }

  return extraProps;
}

addFilter('blocks.registerBlockType', 'lubus/background/attribute', addAttribute);
addFilter('blocks.BlockEdit', 'lubus/background/inspector', withInspectorControl);
addFilter('editor.BlockListBlock', 'lubus/background/withBackground', withBackground);
addFilter('blocks.getSaveContent.extraProps', 'lubus/background/addAssignedBackground', addBackground);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Attributes Object
 */
var backgroundSettings = {
	backgroundType: {
		type: 'string'
	},
	solidColor: {
		type: 'string'
	},
	gradient: {
		type: 'string'
	},
	mediaID: {
		type: 'number'
	},
	mediaURL: {
		type: 'string'
	},
	overlay: {
		type: 'boolean'
	},
	overlayType: {
		type: 'string'
	},
	opacity: {
		type: 'number',
		default: 5
	}
};

/* harmony default export */ __webpack_exports__["a"] = (backgroundSettings);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_options__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_gradients__ = __webpack_require__(7);
/**
 * WordPress Dependencies
 */
var __ = wp.i18n.__;
var _wp$blocks = wp.blocks,
    InspectorControls = _wp$blocks.InspectorControls,
    ColorPalette = _wp$blocks.ColorPalette,
    MediaUpload = _wp$blocks.MediaUpload;
var _wp$components = wp.components,
    PanelBody = _wp$components.PanelBody,
    Button = _wp$components.Button,
    ButtonGroup = _wp$components.ButtonGroup,
    SelectControl = _wp$components.SelectControl,
    ToggleControl = _wp$components.ToggleControl,
    RangeControl = _wp$components.RangeControl;
var Fragment = wp.element.Fragment;

/**
 * Internal Dependencies
 */




/**
 *
 * @param {object} props component props
 * @returns {object} Component
 */
var Inspector = function Inspector(props) {
	// Attributes
	var attributes = props.attributes,
	    setAttributes = props.setAttributes;
	var backgroundType = attributes.backgroundType,
	    solidColor = attributes.solidColor,
	    gradient = attributes.gradient,
	    mediaID = attributes.mediaID,
	    mediaURL = attributes.mediaURL,
	    overlay = attributes.overlay,
	    overlayType = attributes.overlayType,
	    opacity = attributes.opacity;

	// Event(s)

	var onChangeBackgroundType = function onChangeBackgroundType(newType) {
		setAttributes({
			backgroundType: newType,
			overlay: undefined,
			overlayType: undefined
		});
	};
	var onChangeSolidColor = function onChangeSolidColor(newColor) {
		setAttributes({ solidColor: newColor });
	};
	var onChangeGradient = function onChangeGradient(newGradient) {
		setAttributes({ gradient: newGradient });
	};
	var onSelectImage = function onSelectImage(media) {
		setAttributes({
			mediaID: media.id,
			mediaURL: media.url
		});
	};
	var onRemoveImage = function onRemoveImage() {
		setAttributes({
			mediaID: undefined,
			mediaURL: undefined
		});
	};
	var onChangeOverlay = function onChangeOverlay(newOverlay) {
		setAttributes({ overlay: newOverlay });
	};
	var onChangeOverlayType = function onChangeOverlayType(newType) {
		setAttributes({ overlayType: newType });
	};
	var onChangeOpacity = function onChangeOpacity(newOpacity) {
		setAttributes({ opacity: newOpacity });
	};

	// Controls
	var colorControl = wp.element.createElement(ColorPalette, {
		value: solidColor,
		onChange: onChangeSolidColor
	});

	var gradientControl = wp.element.createElement(SelectControl, {
		label: __('Gradient Presets'),
		options: __WEBPACK_IMPORTED_MODULE_1__data_gradients__["a" /* default */].map(function (preset) {
			return {
				value: preset.colors,
				label: preset.name
			};
		}),
		value: gradient,
		onChange: onChangeGradient
	});

	// Inspector Controls
	return wp.element.createElement(
		InspectorControls,
		null,
		wp.element.createElement(
			PanelBody,
			{ title: __('Background Settings'), initialOpen: true },
			wp.element.createElement(
				ButtonGroup,
				{ 'aria-label': __('Background Type') },
				__WEBPACK_IMPORTED_MODULE_0__data_options__["a" /* default */].backgroundType.map(function (type) {
					return wp.element.createElement(
						Button,
						{
							key: type.label,
							isLarge: true,
							isPrimary: backgroundType === type.value,
							'aria-pressed': backgroundType === type.value,
							onClick: function onClick() {
								return onChangeBackgroundType(type.value);
							}
						},
						type.label
					);
				})
			),
			'color' === backgroundType && colorControl,
			'gradient' === backgroundType && gradientControl,
			'image' === backgroundType && wp.element.createElement(MediaUpload, {
				key: 'mediaupload',
				onSelect: onSelectImage,
				type: 'image',
				value: mediaID,
				render: function render(_ref) {
					var open = _ref.open;
					return wp.element.createElement(
						Fragment,
						null,
						wp.element.createElement(
							Button,
							{
								className: 'button-link',
								onClick: open },
							!mediaID ? __('Set background image') : wp.element.createElement('img', { src: mediaURL })
						)
					);
				}
			}),

			// Actions for background image selected
			'image' === backgroundType && mediaID && wp.element.createElement(
				Fragment,
				null,
				wp.element.createElement(
					'p',
					{ className: 'editor-post-featured-image__howto' },
					__('Click the image to edit or update')
				),
				wp.element.createElement(
					Button,
					{
						className: 'button-link',
						style: { marginBottom: '20px' },
						onClick: onRemoveImage },
					__('Remove background image')
				)
			),
			'image' === backgroundType && mediaID && wp.element.createElement(ToggleControl, {
				key: 'togglecontrol',
				label: __('Overlay'),
				checked: !!overlay,
				onChange: onChangeOverlay
			}),
			overlay && wp.element.createElement(
				ButtonGroup,
				{ 'aria-label': __('Overlay Type'), key: 'overlaytype' },
				__WEBPACK_IMPORTED_MODULE_0__data_options__["a" /* default */].backgroundType.map(function (type) {
					if ('image' === type.value) {
						return;
					}

					return wp.element.createElement(
						Button,
						{
							key: type.label,
							isLarge: true,
							isPrimary: overlayType === type.value,
							'aria-pressed': overlayType === type.value,
							onClick: function onClick() {
								return onChangeOverlayType(type.value);
							}
						},
						type.label
					);
				})
			),
			overlay && 'color' === overlayType && colorControl,
			overlay && 'gradient' === overlayType && gradientControl,
			overlay && ('color' === overlayType || 'gradient' === overlayType) && wp.element.createElement(RangeControl, {
				key: 'rangecontrol',
				label: 'Opacity',
				value: opacity,
				onChange: onChangeOpacity,
				min: 1,
				max: 10
			})
		)
	);
};

/* harmony default export */ __webpack_exports__["a"] = (Inspector);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Options for radio/select
 */

var options = {};

options.backgroundType = [{ label: 'Color', value: 'color' }, { label: 'Gradient', value: 'gradient' }, { label: 'Image', value: 'image' }];

/* harmony default export */ __webpack_exports__["a"] = (options);

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gradients Preset Object
 */
var gradients = [{
	name: 'Select Gradient',
	colors: -1
}, {
	name: 'Berimbolo',
	colors: ['#02111D', '#037BB5', '#02111D']
}, {
	name: 'Mango',
	colors: ['#ffe259', '#ffa751']
}, {
	name: 'Windy',
	colors: ['#acb6e5', '#86fde8']
}, {
	name: 'Royal Blue',
	colors: ['#536976', '#292E49']
}, {
	name: 'Royal Blue + Petrol',
	colors: ['#BBD2C5', '#536976', '#292E49']
}, {
	name: 'Copper',
	colors: ['#B79891', '#94716B']
}, {
	name: 'Petrol',
	colors: ['#BBD2C5', '#536976']
}, {
	name: 'Sky',
	colors: ['#076585', '#fff']
}, {
	name: 'Sel',
	colors: ['#00467F', '#A5CC82']
}, {
	name: 'Skyline',
	colors: ['#1488CC', '#2B32B2']
}, {
	name: 'DIMIGO',
	colors: ['#ec008c', '#fc6767']
}, {
	name: 'Purple Love',
	colors: ['#cc2b5e', '#753a88']
}, {
	name: 'Sexy Blue',
	colors: ['#2193b0', '#6dd5ed']
}, {
	name: 'Blooker20',
	colors: ['#e65c00', '#F9D423']
}, {
	name: 'Sea Blue',
	colors: ['#2b5876', '#4e4376']
}, {
	name: 'Nimvelo',
	colors: ['#314755', '#26a0da']
}, {
	name: 'Hazel',
	colors: ['#77A1D3', '#79CBCA', '#E684AE']
}, {
	name: 'Noon to Dusk',
	colors: ['#ff6e7f', '#bfe9ff']
}, {
	name: 'YouTube',
	colors: ['#e52d27', '#b31217']
}, {
	name: 'Cool Brown',
	colors: ['#603813', '#b29f94']
}, {
	name: 'Harmonic Energy',
	colors: ['#16A085', '#F4D03F']
}, {
	name: 'Playing with Reds',
	colors: ['#D31027', '#EA384D']
}, {
	name: 'Sunny Days',
	colors: ['#EDE574', '#E1F5C4']
}, {
	name: 'Green Beach',
	colors: ['#02AAB0', '#00CDAC']
}, {
	name: 'Intuitive Purple',
	colors: ['#DA22FF', '#9733EE']
}, {
	name: 'Emerald Water',
	colors: ['#348F50', '#56B4D3']
}, {
	name: 'Lemon Twist',
	colors: ['#3CA55C', '#B5AC49']
}, {
	name: 'Monte Carlo',
	colors: ['#CC95C0', '#DBD4B4', '#7AA1D2']
}, {
	name: 'Horizon',
	colors: ['#003973', '#E5E5BE']
}, {
	name: 'Rose Water',
	colors: ['#E55D87', '#5FC3E4']
}, {
	name: 'Frozen',
	colors: ['#403B4A', '#E7E9BB']
}, {
	name: 'Mango Pulp',
	colors: ['#F09819', '#EDDE5D']
}, {
	name: 'Bloody Mary',
	colors: ['#FF512F', '#DD2476']
}, {
	name: 'Aubergine',
	colors: ['#AA076B', '#61045F']
}, {
	name: 'Aqua Marine',
	colors: ['#1A2980', '#26D0CE']
}, {
	name: 'Sunrise',
	colors: ['#FF512F', '#F09819']
}, {
	name: 'Purple Paradise',
	colors: ['#1D2B64', '#F8CDDA']
}, {
	name: 'Stripe',
	colors: ['#1FA2FF', '#12D8FA', '#A6FFCB']
}, {
	name: 'Sea Weed',
	colors: ['#4CB8C4', '#3CD3AD']
}, {
	name: 'Pinky',
	colors: ['#DD5E89', '#F7BB97']
}, {
	name: 'Cherry',
	colors: ['#EB3349', '#F45C43']
}, {
	name: 'Mojito',
	colors: ['#1D976C', '#93F9B9']
}, {
	name: 'Juicy Orange',
	colors: ['#FF8008', '#FFC837']
}, {
	name: 'Mirage',
	colors: ['#16222A', '#3A6073']
}, {
	name: 'Steel Gray',
	colors: ['#1F1C2C', '#928DAB']
}, {
	name: 'Kashmir',
	colors: ['#614385', '#516395']
}, {
	name: 'Electric Violet',
	colors: ['#4776E6', '#8E54E9']
}, {
	name: 'Venice Blue',
	colors: ['#085078', '#85D8CE']
}, {
	name: 'Bora Bora',
	colors: ['#2BC0E4', '#EAECC6']
}, {
	name: 'Moss',
	colors: ['#134E5E', '#71B280']
}, {
	name: 'Shroom Haze',
	colors: ['#5C258D', '#4389A2']
}, {
	name: 'Mystic',
	colors: ['#757F9A', '#D7DDE8']
}, {
	name: 'Midnight City',
	colors: ['#232526', '#414345']
}, {
	name: 'Sea Blizz',
	colors: ['#1CD8D2', '#93EDC7']
}, {
	name: 'Opa',
	colors: ['#3D7EAA', '#FFE47A']
}, {
	name: 'Titanium',
	colors: ['#283048', '#859398']
}, {
	name: 'Mantle',
	colors: ['#24C6DC', '#514A9D']
}, {
	name: 'Dracula',
	colors: ['#DC2424', '#4A569D']
}, {
	name: 'Peach',
	colors: ['#ED4264', '#FFEDBC']
}, {
	name: 'Moonrise',
	colors: ['#DAE2F8', '#D6A4A4']
}, {
	name: 'Clouds',
	colors: ['#ECE9E6', '#FFFFFF']
}, {
	name: 'Stellar',
	colors: ['#7474BF', '#348AC7']
}, {
	name: 'Bourbon',
	colors: ['#EC6F66', '#F3A183']
}, {
	name: 'Calm Darya',
	colors: ['#5f2c82', '#49a09d']
}, {
	name: 'Influenza',
	colors: ['#C04848', '#480048']
}, {
	name: 'Shrimpy',
	colors: ['#e43a15', '#e65245']
}, {
	name: 'Army',
	colors: ['#414d0b', '#727a17']
}, {
	name: 'Miaka',
	colors: ['#FC354C', '#0ABFBC']
}, {
	name: 'Pinot Noir',
	colors: ['#4b6cb7', '#182848']
}, {
	name: 'Day Tripper',
	colors: ['#f857a6', '#ff5858']
}, {
	name: 'Namn',
	colors: ['#a73737', '#7a2828']
}, {
	name: 'Blurry Beach',
	colors: ['#d53369', '#cbad6d']
}, {
	name: 'Vasily',
	colors: ['#e9d362', '#333333']
}, {
	name: 'A Lost Memory',
	colors: ['#DE6262', '#FFB88C']
}, {
	name: 'Petrichor',
	colors: ['#666600', '#999966']
}, {
	name: 'Jonquil',
	colors: ['#FFEEEE', '#DDEFBB']
}, {
	name: 'Sirius Tamed',
	colors: ['#EFEFBB', '#D4D3DD']
}, {
	name: 'Kyoto',
	colors: ['#c21500', '#ffc500']
}, {
	name: 'Misty Meadow',
	colors: ['#215f00', '#e4e4d9']
}, {
	name: 'Aqualicious',
	colors: ['#50C9C3', '#96DEDA']
}, {
	name: 'Moor',
	colors: ['#616161', '#9bc5c3']
}, {
	name: 'Almost',
	colors: ['#ddd6f3', '#faaca8']
}, {
	name: 'Forever Lost',
	colors: ['#5D4157', '#A8CABA']
}, {
	name: 'Winter',
	colors: ['#E6DADA', '#274046']
}, {
	name: 'Autumn',
	colors: ['#DAD299', '#B0DAB9']
}, {
	name: 'Candy',
	colors: ['#D3959B', '#BFE6BA']
}, {
	name: 'Reef',
	colors: ['#00d2ff', '#3a7bd5']
}, {
	name: 'The Strain',
	colors: ['#870000', '#190A05']
}, {
	name: 'Dirty Fog',
	colors: ['#B993D6', '#8CA6DB']
}, {
	name: 'Earthly',
	colors: ['#649173', '#DBD5A4']
}, {
	name: 'Virgin',
	colors: ['#C9FFBF', '#FFAFBD']
}, {
	name: 'Ash',
	colors: ['#606c88', '#3f4c6b']
}, {
	name: 'Shadow Night',
	colors: ['#000000', '#53346D']
}, {
	name: 'Cherryblossoms',
	colors: ['#FBD3E9', '#BB377D']
}, {
	name: 'Parklife',
	colors: ['#ADD100', '#7B920A']
}, {
	name: 'Dance To Forget',
	colors: ['#FF4E50', '#F9D423']
}, {
	name: 'Starfall',
	colors: ['#F0C27B', '#4B1248']
}, {
	name: 'Red Mist',
	colors: ['#000000', '#e74c3c']
}, {
	name: 'Teal Love',
	colors: ['#AAFFA9', '#11FFBD']
}, {
	name: 'Neon Life',
	colors: ['#B3FFAB', '#12FFF7']
}, {
	name: 'Man of Steel',
	colors: ['#780206', '#061161']
}, {
	name: 'Amethyst',
	colors: ['#9D50BB', '#6E48AA']
}, {
	name: 'Cheer Up Emo Kid',
	colors: ['#556270', '#FF6B6B']
}, {
	name: 'Shore',
	colors: ['#70e1f5', '#ffd194']
}, {
	name: 'Facebook Messenger',
	colors: ['#00c6ff', '#0072ff']
}, {
	name: 'SoundCloud',
	colors: ['#fe8c00', '#f83600']
}, {
	name: 'Behongo',
	colors: ['#52c234', '#061700']
}, {
	name: 'ServQuick',
	colors: ['#485563', '#29323c']
}, {
	name: 'Friday',
	colors: ['#83a4d4', '#b6fbff']
}, {
	name: 'Martini',
	colors: ['#FDFC47', '#24FE41']
}, {
	name: 'Metallic Toad',
	colors: ['#abbaab', '#ffffff']
}, {
	name: 'Between The Clouds',
	colors: ['#73C8A9', '#373B44']
}, {
	name: 'Crazy Orange I',
	colors: ['#D38312', '#A83279']
}, {
	name: 'Hersheys',
	colors: ['#1e130c', '#9a8478']
}, {
	name: 'Talking To Mice Elf',
	colors: ['#948E99', '#2E1437']
}, {
	name: 'Purple Bliss',
	colors: ['#360033', '#0b8793']
}, {
	name: 'Predawn',
	colors: ['#FFA17F', '#00223E']
}, {
	name: 'Endless River',
	colors: ['#43cea2', '#185a9d']
}, {
	name: 'Pastel Orange at the Sun',
	colors: ['#ffb347', '#ffcc33']
}, {
	name: 'Twitch',
	colors: ['#6441A5', '#2a0845']
}, {
	name: 'Atlas',
	colors: ['#FEAC5E', '#C779D0', '#4BC0C8']
}, {
	name: 'Instagram',
	colors: ['#833ab4', '#fd1d1d', '#fcb045']
}, {
	name: 'Flickr',
	colors: ['#ff0084', '#33001b']
}, {
	name: 'Vine',
	colors: ['#00bf8f', '#001510']
}, {
	name: 'Turquoise flow',
	colors: ['#136a8a', '#267871']
}, {
	name: 'Portrait',
	colors: ['#8e9eab', '#eef2f3']
}, {
	name: 'Virgin America',
	colors: ['#7b4397', '#dc2430']
}, {
	name: 'Koko Caramel',
	colors: ['#D1913C', '#FFD194']
}, {
	name: 'Fresh Turboscent',
	colors: ['#F1F2B5', '#135058']
}, {
	name: 'Green to dark',
	colors: ['#6A9113', '#141517']
}, {
	name: 'Ukraine',
	colors: ['#004FF9', '#FFF94C']
}, {
	name: 'Curiosity blue',
	colors: ['#525252', '#3d72b4']
}, {
	name: 'Dark Knight',
	colors: ['#BA8B02', '#181818']
}, {
	name: 'Piglet',
	colors: ['#ee9ca7', '#ffdde1']
}, {
	name: 'Lizard',
	colors: ['#304352', '#d7d2cc']
}, {
	name: 'Sage Persuasion',
	colors: ['#CCCCB2', '#757519']
}, {
	name: 'Between Night and Day',
	colors: ['#2c3e50', '#3498db']
}, {
	name: 'Timber',
	colors: ['#fc00ff', '#00dbde']
}, {
	name: 'Passion',
	colors: ['#e53935', '#e35d5b']
}, {
	name: 'Clear Sky',
	colors: ['#005C97', '#363795']
}, {
	name: 'Master Card',
	colors: ['#f46b45', '#eea849']
}, {
	name: 'Back To Earth',
	colors: ['#00C9FF', '#92FE9D']
}, {
	name: 'Deep Purple',
	colors: ['#673AB7', '#512DA8']
}, {
	name: 'Little Leaf',
	colors: ['#76b852', '#8DC26F']
}, {
	name: 'Netflix',
	colors: ['#8E0E00', '#1F1C18']
}, {
	name: 'Light Orange',
	colors: ['#FFB75E', '#ED8F03']
}, {
	name: 'Green and Blue',
	colors: ['#c2e59c', '#64b3f4']
}, {
	name: 'Poncho',
	colors: ['#403A3E', '#BE5869']
}, {
	name: 'Back to the Future',
	colors: ['#C02425', '#F0CB35']
}, {
	name: 'Blush',
	colors: ['#B24592', '#F15F79']
}, {
	name: 'Inbox',
	colors: ['#457fca', '#5691c8']
}, {
	name: 'Purplin',
	colors: ['#6a3093', '#a044ff']
}, {
	name: 'Pale Wood',
	colors: ['#eacda3', '#d6ae7b']
}, {
	name: 'Haikus',
	colors: ['#fd746c', '#ff9068']
}, {
	name: 'Pizelex',
	colors: ['#114357', '#F29492']
}, {
	name: 'Joomla',
	colors: ['#1e3c72', '#2a5298']
}, {
	name: 'Christmas',
	colors: ['#2F7336', '#AA3A38']
}, {
	name: 'Minnesota Vikings',
	colors: ['#5614B0', '#DBD65C']
}, {
	name: 'Miami Dolphins',
	colors: ['#4DA0B0', '#D39D38']
}, {
	name: 'Forest',
	colors: ['#5A3F37', '#2C7744']
}, {
	name: 'Nighthawk',
	colors: ['#2980b9', '#2c3e50']
}, {
	name: 'Superman',
	colors: ['#0099F7', '#F11712']
}, {
	name: 'Suzy',
	colors: ['#834d9b', '#d04ed6']
}, {
	name: 'Dark Skies',
	colors: ['#4B79A1', '#283E51']
}, {
	name: 'Deep Space',
	colors: ['#000000', '#434343']
}, {
	name: 'Decent',
	colors: ['#4CA1AF', '#C4E0E5']
}, {
	name: 'Colors Of Sky',
	colors: ['#E0EAFC', '#CFDEF3']
}, {
	name: 'Purple White',
	colors: ['#BA5370', '#F4E2D8']
}, {
	name: 'Ali',
	colors: ['#ff4b1f', '#1fddff']
}, {
	name: 'Alihossein',
	colors: ['#f7ff00', '#db36a4']
}, {
	name: 'Shahabi',
	colors: ['#a80077', '#66ff00']
}, {
	name: 'Red Ocean',
	colors: ['#1D4350', '#A43931']
}, {
	name: 'Tranquil',
	colors: ['#EECDA3', '#EF629F']
}, {
	name: 'Transfile',
	colors: ['#16BFFD', '#CB3066']
}, {
	name: 'Sylvia',
	colors: ['#ff4b1f', '#ff9068']
}, {
	name: 'Sweet Morning',
	colors: ['#FF5F6D', '#FFC371']
}, {
	name: 'Politics',
	colors: ['#2196f3', '#f44336']
}, {
	name: 'Bright Vault',
	colors: ['#00d2ff', '#928DAB']
}, {
	name: 'Solid Vault',
	colors: ['#3a7bd5', '#3a6073']
}, {
	name: 'Sunset',
	colors: ['#0B486B', '#F56217']
}, {
	name: 'Grapefruit Sunset',
	colors: ['#e96443', '#904e95']
}, {
	name: 'Deep Sea Space',
	colors: ['#2C3E50', '#4CA1AF']
}, {
	name: 'Dusk',
	colors: ['#2C3E50', '#FD746C']
}, {
	name: 'Minimal Red',
	colors: ['#F00000', '#DC281E']
}, {
	name: 'Royal',
	colors: ['#141E30', '#243B55']
}, {
	name: 'Mauve',
	colors: ['#42275a', '#734b6d']
}, {
	name: 'Frost',
	colors: ['#000428', '#004e92']
}, {
	name: 'Lush',
	colors: ['#56ab2f', '#a8e063']
}, {
	name: 'Firewatch',
	colors: ['#cb2d3e', '#ef473a']
}, {
	name: 'Sherbert',
	colors: ['#f79d00', '#64f38c']
}, {
	name: 'Blood Red',
	colors: ['#f85032', '#e73827']
}, {
	name: 'Sun on the Horizon',
	colors: ['#fceabb', '#f8b500']
}, {
	name: 'IIIT Delhi',
	colors: ['#808080', '#3fada8']
}, {
	name: 'Dusk',
	colors: ['#ffd89b', '#19547b']
}, {
	name: '50 Shades of Grey',
	colors: ['#bdc3c7', '#2c3e50']
}, {
	name: 'Dania',
	colors: ['#BE93C5', '#7BC6CC']
}, {
	name: 'Limeade',
	colors: ['#A1FFCE', '#FAFFD1']
}, {
	name: 'Disco',
	colors: ['#4ECDC4', '#556270']
}, {
	name: 'Love Couple',
	colors: ['#3a6186', '#89253e']
}, {
	name: 'Azure Pop',
	colors: ['#ef32d9', '#89fffd']
}, {
	name: 'Nepal',
	colors: ['#de6161', '#2657eb']
}, {
	name: 'Cosmic Fusion',
	colors: ['#ff00cc', '#333399']
}, {
	name: 'Snapchat',
	colors: ['#fffc00', '#ffffff']
}, {
	name: 'Ed\'s Sunset Gradient',
	colors: ['#ff7e5f', '#feb47b']
}, {
	name: 'Brady Brady Fun Fun',
	colors: ['#00c3ff', '#ffff1c']
}, {
	name: 'Black Rosé',
	colors: ['#f4c4f3', '#fc67fa']
}, {
	name: '80\'s Purple',
	colors: ['#41295a', '#2F0743']
}, {
	name: 'Radar',
	colors: ['#A770EF', '#CF8BF3', '#FDB99B']
}, {
	name: 'Ibiza Sunset',
	colors: ['#ee0979', '#ff6a00']
}, {
	name: 'Dawn',
	colors: ['#F3904F', '#3B4371']
}, {
	name: 'Mild',
	colors: ['#67B26F', '#4ca2cd']
}, {
	name: 'Vice City',
	colors: ['#3494E6', '#EC6EAD']
}, {
	name: 'Jaipur',
	colors: ['#DBE6F6', '#C5796D']
}, {
	name: 'Jodhpur',
	colors: ['#9CECFB', '#65C7F7', '#0052D4']
}, {
	name: 'Cocoaa Ice',
	colors: ['#c0c0aa', '#1cefff']
}, {
	name: 'EasyMed',
	colors: ['#DCE35B', '#45B649']
}, {
	name: 'Rose Colored Lenses',
	colors: ['#E8CBC0', '#636FA4']
}, {
	name: 'What lies Beyond',
	colors: ['#F0F2F0', '#000C40']
}, {
	name: 'Roseanna',
	colors: ['#FFAFBD', '#ffc3a0']
}, {
	name: 'Honey Dew',
	colors: ['#43C6AC', '#F8FFAE']
}, {
	name: 'Under the Lake',
	colors: ['#093028', '#237A57']
}, {
	name: 'The Blue Lagoon',
	colors: ['#43C6AC', '#191654']
}, {
	name: 'Can You Feel The Love Tonight',
	colors: ['#4568DC', '#B06AB3']
}, {
	name: 'Very Blue',
	colors: ['#0575E6', '#021B79']
}, {
	name: 'Love and Liberty',
	colors: ['#200122', '#6f0000']
}, {
	name: 'Orca',
	colors: ['#44A08D', '#093637']
}, {
	name: 'Venice',
	colors: ['#6190E8', '#A7BFE8']
}, {
	name: 'Pacific Dream',
	colors: ['#34e89e', '#0f3443']
}, {
	name: 'Learning and Leading',
	colors: ['#F7971E', '#FFD200']
}, {
	name: 'Celestial',
	colors: ['#C33764', '#1D2671']
}, {
	name: 'Purplepine',
	colors: ['#20002c', '#cbb4d4']
}, {
	name: 'Sha la la',
	colors: ['#D66D75', '#E29587']
}, {
	name: 'Mini',
	colors: ['#30E8BF', '#FF8235']
}, {
	name: 'Maldives',
	colors: ['#B2FEFA', '#0ED2F7']
}, {
	name: 'Cinnamint',
	colors: ['#4AC29A', '#BDFFF3']
}, {
	name: 'Html',
	colors: ['#E44D26', '#F16529']
}, {
	name: 'Coal',
	colors: ['#EB5757', '#000000']
}, {
	name: 'Sunkist',
	colors: ['#F2994A', '#F2C94C']
}, {
	name: 'Blue Skies',
	colors: ['#56CCF2', '#2F80ED']
}, {
	name: 'Chitty Chitty Bang Bang',
	colors: ['#007991', '#78ffd6']
}, {
	name: 'Visions of Grandeur',
	colors: ['#000046', '#1CB5E0']
}, {
	name: 'Crystal Clear',
	colors: ['#159957', '#155799']
}, {
	name: 'Mello',
	colors: ['#c0392b', '#8e44ad']
}, {
	name: 'Compare Now',
	colors: ['#EF3B36', '#FFFFFF']
}, {
	name: 'Meridian',
	colors: ['#283c86', '#45a247']
}, {
	name: 'Relay',
	colors: ['#3A1C71', '#D76D77', '#FFAF7B']
}, {
	name: 'Alive',
	colors: ['#CB356B', '#BD3F32']
}, {
	name: 'Scooter',
	colors: ['#36D1DC', '#5B86E5']
}, {
	name: 'Terminal',
	colors: ['#000000', '#0f9b0f']
}, {
	name: 'Telegram',
	colors: ['#1c92d2', '#f2fcfe']
}, {
	name: 'Crimson Tide',
	colors: ['#642B73', '#C6426E']
}, {
	name: 'Socialive',
	colors: ['#06beb6', '#48b1bf']
}, {
	name: 'Subu',
	colors: ['#0cebeb', '#20e3b2', '#29ffc6']
}, {
	name: 'Shift',
	colors: ['#000000', '#E5008D', '#FF070B']
}, {
	name: 'Clot',
	colors: ['#070000', '#4C0001', '#070000']
}, {
	name: 'Broken Hearts',
	colors: ['#d9a7c7', '#fffcdc']
}, {
	name: 'Kimoby Is The New Blue',
	colors: ['#396afc', '#2948ff']
}, {
	name: 'Dull',
	colors: ['#C9D6FF', '#E2E2E2']
}, {
	name: 'Purpink',
	colors: ['#7F00FF', '#E100FF']
}, {
	name: 'Orange Coral',
	colors: ['#ff9966', '#ff5e62']
}, {
	name: 'Summer',
	colors: ['#22c1c3', '#fdbb2d']
}, {
	name: 'King Yna',
	colors: ['#1a2a6c', '#b21f1f', '#fdbb2d']
}, {
	name: 'Velvet Sun',
	colors: ['#e1eec3', '#f05053']
}, {
	name: 'Zinc',
	colors: ['#ADA996', '#F2F2F2', '#DBDBDB', '#EAEAEA']
}, {
	name: 'Hydrogen',
	colors: ['#667db6', '#0082c8', '#0082c8', '#667db6']
}, {
	name: 'Argon',
	colors: ['#03001e', '#7303c0', '#ec38bc', '#fdeff9']
}, {
	name: 'Lithium',
	colors: ['#6D6027', '#D3CBB8']
}, {
	name: 'Digital Water',
	colors: ['#74ebd5', '#ACB6E5']
}, {
	name: 'Velvet Sun',
	colors: ['#e1eec3', '#f05053']
}, {
	name: 'Orange Fun',
	colors: ['#fc4a1a', '#f7b733']
}, {
	name: 'Rainbow Blue',
	colors: ['#00F260', '#0575E6']
}, {
	name: 'Pink Flavour',
	colors: ['#800080', '#ffc0cb']
}, {
	name: 'Sulphur',
	colors: ['#CAC531', '#F3F9A7']
}, {
	name: 'Selenium',
	colors: ['#3C3B3F', '#605C3C']
}, {
	name: 'Delicate',
	colors: ['#D3CCE3', '#E9E4F0']
}, {
	name: 'Ohhappiness',
	colors: ['#00b09b', '#96c93d']
}, {
	name: 'Lawrencium',
	colors: ['#0f0c29', '#302b63', '#24243e']
}, {
	name: 'Relaxing red',
	colors: ['#fffbd5', '#b20a2c']
}, {
	name: 'Taran Tado',
	colors: ['#23074d', '#cc5333']
}, {
	name: 'Bighead',
	colors: ['#c94b4b', '#4b134f']
}, {
	name: 'Sublime Vivid',
	colors: ['#FC466B', '#3F5EFB']
}, {
	name: 'Sublime Light',
	colors: ['#FC5C7D', '#6A82FB']
}, {
	name: 'Pun Yeta',
	colors: ['#108dc7', '#ef8e38']
}, {
	name: 'Quepal',
	colors: ['#11998e', '#38ef7d']
}, {
	name: 'Sand to Blue',
	colors: ['#3E5151', '#DECBA4']
}, {
	name: 'Wedding Day Blues',
	colors: ['#40E0D0', '#FF8C00', '#FF0080']
}, {
	name: 'Shifter',
	colors: ['#bc4e9c', '#f80759']
}, {
	name: 'Red Sunset',
	colors: ['#355C7D', '#6C5B7B', '#C06C84']
}, {
	name: 'Moon Purple',
	colors: ['#4e54c8', '#8f94fb']
}, {
	name: 'Pure Lust',
	colors: ['#333333', '#dd1818']
}, {
	name: 'Slight Ocean View',
	colors: ['#a8c0ff', '#3f2b96']
}, {
	name: 'eXpresso',
	colors: ['#ad5389', '#3c1053']
}, {
	name: 'Shifty',
	colors: ['#636363', '#a2ab58']
}, {
	name: 'Vanusa',
	colors: ['#DA4453', '#89216B']
}, {
	name: 'Evening Night',
	colors: ['#005AA7', '#FFFDE4']
}];

/* harmony default export */ __webpack_exports__["a"] = (gradients);

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_overlay__ = __webpack_require__(9);
/**
 * Internal Dependencies
 */


/**
 * Generate Style Object for background
 */

function getStyle(attributes) {
	// Block Settings
	var backgroundType = attributes.backgroundType,
	    solidColor = attributes.solidColor,
	    gradient = attributes.gradient,
	    mediaURL = attributes.mediaURL,
	    overlay = attributes.overlay,
	    overlayType = attributes.overlayType,
	    opacity = attributes.opacity;

	// Style

	var style = {};

	switch (backgroundType) {
		case 'color':
			style = { background: solidColor };
			break;

		case 'gradient':
			style = { background: 'linear-gradient(to bottom, ' + gradient + ')' };
			break;

		case 'image':
			// TOOD: Refactor
			if (overlay && ('color' === overlayType || 'gradient' === overlayType)) {
				switch (overlayType) {
					case 'color':
						if (solidColor) {
							var overlaySolid = solidColor + ', ' + solidColor;
							style = {
								background: 'linear-gradient(to bottom, ' + Object(__WEBPACK_IMPORTED_MODULE_0__get_overlay__["a" /* default */])(overlaySolid, opacity) + ' ), url( ' + mediaURL + ' )',
								backgroundSize: 'cover'
							};
						} else {
							style = {
								background: 'url( ' + mediaURL + ' )',
								backgroundSize: 'cover'
							};
						}
						break;

					case 'gradient':
						if (gradient) {
							style = {
								background: 'linear-gradient(to bottom, ' + Object(__WEBPACK_IMPORTED_MODULE_0__get_overlay__["a" /* default */])(gradient, opacity) + '), url( ' + mediaURL + ' )',
								backgroundSize: 'cover'
							};
						} else {
							style = {
								background: 'url( ' + mediaURL + ' )',
								backgroundSize: 'cover'
							};
						}

						break;
				}
			} else {
				style = {
					background: 'url( ' + mediaURL + ' )',
					backgroundSize: 'cover'
				};
			}

			break;
	}
	return style;
}

/* harmony default export */ __webpack_exports__["a"] = (getStyle);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tinycolor2__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tinycolor2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tinycolor2__);
/**
 * External Dependencies
 */


/**
 * Generate overlay
 *
 * @param {string} colors comma seperated list of colors
 * @param {number} opacity overlay opacity
 *
 * @returns {string} color overlay
 */
var getOverlay = function getOverlay(colors, opacity) {
	var objColors = colors.split(',');
	var overlayAlpha = opacity / 10;

	var cssColor = objColors.map(function (colorCode) {
		var color = __WEBPACK_IMPORTED_MODULE_0_tinycolor2___default()(colorCode);
		color.toRgbString(); // "rgb(255, 0, 0)"
		color.setAlpha(overlayAlpha);
		color.toRgbString(); // "rgba(255, 0, 0, 0.5)"
		return color;
	}).join(',');

	return cssColor;
};

/* harmony default export */ __webpack_exports__["a"] = (getOverlay);

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// TinyColor v1.4.1
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

(function(Math) {

var trimLeft = /^\s+/,
    trimRight = /\s+$/,
    tinyCounter = 0,
    mathRound = Math.round,
    mathMin = Math.min,
    mathMax = Math.max,
    mathRandom = Math.random;

function tinycolor (color, opts) {

    color = (color) ? color : '';
    opts = opts || { };

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
       return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
        return new tinycolor(color, opts);
    }

    var rgb = inputToRGB(color);
    this._originalInput = color,
    this._r = rgb.r,
    this._g = rgb.g,
    this._b = rgb.b,
    this._a = rgb.a,
    this._roundA = mathRound(100*this._a) / 100,
    this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) { this._r = mathRound(this._r); }
    if (this._g < 1) { this._g = mathRound(this._g); }
    if (this._b < 1) { this._b = mathRound(this._b); }

    this._ok = rgb.ok;
    this._tc_id = tinyCounter++;
}

tinycolor.prototype = {
    isDark: function() {
        return this.getBrightness() < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    isValid: function() {
        return this._ok;
    },
    getOriginalInput: function() {
      return this._originalInput;
    },
    getFormat: function() {
        return this._format;
    },
    getAlpha: function() {
        return this._a;
    },
    getBrightness: function() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r/255;
        GsRGB = rgb.g/255;
        BsRGB = rgb.b/255;

        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
    },
    setAlpha: function(value) {
        this._a = boundAlpha(value);
        this._roundA = mathRound(100*this._a) / 100;
        return this;
    },
    toHsv: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
    },
    toHsvString: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
        return (this._a == 1) ?
          "hsv("  + h + ", " + s + "%, " + v + "%)" :
          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
    },
    toHsl: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
    },
    toHslString: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
        return (this._a == 1) ?
          "hsl("  + h + ", " + s + "%, " + l + "%)" :
          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
    },
    toHex: function(allow3Char) {
        return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function(allow3Char) {
        return '#' + this.toHex(allow3Char);
    },
    toHex8: function(allow4Char) {
        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function(allow4Char) {
        return '#' + this.toHex8(allow4Char);
    },
    toRgb: function() {
        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
    },
    toRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function() {
        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
    },
    toPercentageRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function() {
        if (this._a === 0) {
            return "transparent";
        }

        if (this._a < 1) {
            return false;
        }

        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function(secondColor) {
        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";

        if (secondColor) {
            var s = tinycolor(secondColor);
            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }

        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
    },
    toString: function(format) {
        var formatSet = !!format;
        format = format || this._format;

        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) {
                return this.toName();
            }
            return this.toRgbString();
        }
        if (format === "rgb") {
            formattedString = this.toRgbString();
        }
        if (format === "prgb") {
            formattedString = this.toPercentageRgbString();
        }
        if (format === "hex" || format === "hex6") {
            formattedString = this.toHexString();
        }
        if (format === "hex3") {
            formattedString = this.toHexString(true);
        }
        if (format === "hex4") {
            formattedString = this.toHex8String(true);
        }
        if (format === "hex8") {
            formattedString = this.toHex8String();
        }
        if (format === "name") {
            formattedString = this.toName();
        }
        if (format === "hsl") {
            formattedString = this.toHslString();
        }
        if (format === "hsv") {
            formattedString = this.toHsvString();
        }

        return formattedString || this.toHexString();
    },
    clone: function() {
        return tinycolor(this.toString());
    },

    _applyModification: function(fn, args) {
        var color = fn.apply(null, [this].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function() {
        return this._applyModification(lighten, arguments);
    },
    brighten: function() {
        return this._applyModification(brighten, arguments);
    },
    darken: function() {
        return this._applyModification(darken, arguments);
    },
    desaturate: function() {
        return this._applyModification(desaturate, arguments);
    },
    saturate: function() {
        return this._applyModification(saturate, arguments);
    },
    greyscale: function() {
        return this._applyModification(greyscale, arguments);
    },
    spin: function() {
        return this._applyModification(spin, arguments);
    },

    _applyCombination: function(fn, args) {
        return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function() {
        return this._applyCombination(analogous, arguments);
    },
    complement: function() {
        return this._applyCombination(complement, arguments);
    },
    monochromatic: function() {
        return this._applyCombination(monochromatic, arguments);
    },
    splitcomplement: function() {
        return this._applyCombination(splitcomplement, arguments);
    },
    triad: function() {
        return this._applyCombination(triad, arguments);
    },
    tetrad: function() {
        return this._applyCombination(tetrad, arguments);
    }
};

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
tinycolor.fromRatio = function(color, opts) {
    if (typeof color == "object") {
        var newColor = {};
        for (var i in color) {
            if (color.hasOwnProperty(i)) {
                if (i === "a") {
                    newColor[i] = color[i];
                }
                else {
                    newColor[i] = convertToPercentage(color[i]);
                }
            }
        }
        color = newColor;
    }

    return tinycolor(color, opts);
};

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function inputToRGB(color) {

    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;

    if (typeof color == "string") {
        color = stringInputToObject(color);
    }

    if (typeof color == "object") {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb = hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l = convertToPercentage(color.l);
            rgb = hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }

        if (color.hasOwnProperty("a")) {
            a = color.a;
        }
    }

    a = boundAlpha(a);

    return {
        ok: ok,
        format: color.format || format,
        r: mathMin(255, mathMax(rgb.r, 0)),
        g: mathMin(255, mathMax(rgb.g, 0)),
        b: mathMin(255, mathMax(rgb.b, 0)),
        a: a
    };
}


// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function rgbToRgb(r, g, b){
    return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255
    };
}

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function rgbToHsl(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, l = (max + min) / 2;

    if(max == min) {
        h = s = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }

        h /= 6;
    }

    return { h: h, s: s, l: l };
}

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hslToRgb(h, s, l) {
    var r, g, b;

    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);

    function hue2rgb(p, q, t) {
        if(t < 0) t += 1;
        if(t > 1) t -= 1;
        if(t < 1/6) return p + (q - p) * 6 * t;
        if(t < 1/2) return q;
        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
    }

    if(s === 0) {
        r = g = b = l; // achromatic
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
    }

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function rgbToHsv(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, v = max;

    var d = max - min;
    s = max === 0 ? 0 : d / max;

    if(max == min) {
        h = 0; // achromatic
    }
    else {
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
 function hsvToRgb(h, s, v) {

    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);

    var i = Math.floor(h),
        f = h - i,
        p = v * (1 - s),
        q = v * (1 - f * s),
        t = v * (1 - (1 - f) * s),
        mod = i % 6,
        r = [v, q, p, p, t, v][mod],
        g = [t, v, v, q, p, p][mod],
        b = [p, p, t, v, v, q][mod];

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function rgbToHex(r, g, b, allow3Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }

    return hex.join("");
}

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function rgbaToHex(r, g, b, a, allow4Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16)),
        pad2(convertDecimalToHex(a))
    ];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }

    return hex.join("");
}

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function rgbaToArgbHex(r, g, b, a) {

    var hex = [
        pad2(convertDecimalToHex(a)),
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    return hex.join("");
}

// `equals`
// Can be called with any tinycolor input
tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) { return false; }
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};

tinycolor.random = function() {
    return tinycolor.fromRatio({
        r: mathRandom(),
        g: mathRandom(),
        b: mathRandom()
    });
};


// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

function desaturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function saturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function greyscale(color) {
    return tinycolor(color).desaturate(100);
}

function lighten (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

function brighten(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var rgb = tinycolor(color).toRgb();
    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
    return tinycolor(rgb);
}

function darken (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
}

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

function complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
}

function triad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
    ];
}

function tetrad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
    ];
}

function splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
    ];
}

function analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;

    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];

    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(tinycolor(hsl));
    }
    return ret;
}

function monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;

    while (results--) {
        ret.push(tinycolor({ h: h, s: s, v: v}));
        v = (v + modification) % 1;
    }

    return ret;
}

// Utility Functions
// ---------------------

tinycolor.mix = function(color1, color2, amount) {
    amount = (amount === 0) ? 0 : (amount || 50);

    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();

    var p = amount / 100;

    var rgba = {
        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
    };

    return tinycolor(rgba);
};


// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
tinycolor.readability = function(color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
};

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
tinycolor.isReadable = function(color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;

    out = false;

    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;

};

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
tinycolor.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size ;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors ;
    level = args.level;
    size = args.size;

    for (var i= 0; i < colorList.length ; i++) {
        readability = tinycolor.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = tinycolor(colorList[i]);
        }
    }

    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
        return bestColor;
    }
    else {
        args.includeFallbackColors=false;
        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
    }
};


// Big List of Colors
// ------------------
// <http://www.w3.org/TR/css3-color/#svg-color>
var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};

// Make it easy to access colors via `hexNames[hex]`
var hexNames = tinycolor.hexNames = flip(names);


// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function flip(o) {
    var flipped = { };
    for (var i in o) {
        if (o.hasOwnProperty(i)) {
            flipped[o[i]] = i;
        }
    }
    return flipped;
}

// Return a valid alpha value [0,1] with all invalid values being set to 1
function boundAlpha(a) {
    a = parseFloat(a);

    if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
    }

    return a;
}

// Take input from [0, n] and return it as [0, 1]
function bound01(n, max) {
    if (isOnePointZero(n)) { n = "100%"; }

    var processPercent = isPercentage(n);
    n = mathMin(max, mathMax(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
        n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if ((Math.abs(n - max) < 0.000001)) {
        return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return (n % max) / parseFloat(max);
}

// Force a number between 0 and 1
function clamp01(val) {
    return mathMin(1, mathMax(0, val));
}

// Parse a base-16 hex value into a base-10 integer
function parseIntFromHex(val) {
    return parseInt(val, 16);
}

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
}

// Check to see if string passed in is a percentage
function isPercentage(n) {
    return typeof n === "string" && n.indexOf('%') != -1;
}

// Force a hex value to have 2 characters
function pad2(c) {
    return c.length == 1 ? '0' + c : '' + c;
}

// Replace a decimal with it's percentage value
function convertToPercentage(n) {
    if (n <= 1) {
        n = (n * 100) + "%";
    }

    return n;
}

// Converts a decimal to a hex value
function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function convertHexToDecimal(h) {
    return (parseIntFromHex(h) / 255);
}

var matchers = (function() {

    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
})();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
}

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function stringInputToObject(color) {

    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
    var named = false;
    if (names[color]) {
        color = names[color];
        named = true;
    }
    else if (color == 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if ((match = matchers.rgb.exec(color))) {
        return { r: match[1], g: match[2], b: match[3] };
    }
    if ((match = matchers.rgba.exec(color))) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    if ((match = matchers.hsl.exec(color))) {
        return { h: match[1], s: match[2], l: match[3] };
    }
    if ((match = matchers.hsla.exec(color))) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    if ((match = matchers.hsv.exec(color))) {
        return { h: match[1], s: match[2], v: match[3] };
    }
    if ((match = matchers.hsva.exec(color))) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    if ((match = matchers.hex8.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex6.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
    }
    if ((match = matchers.hex4.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            a: convertHexToDecimal(match[4] + '' + match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex3.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            format: named ? "name" : "hex"
        };
    }

    return false;
}

function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {"level":"AA", "size":"small"};
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
        level = "AA";
    }
    if (size !== "small" && size !== "large") {
        size = "small";
    }
    return {"level":level, "size":size};
}

// Node: Export function
if (typeof module !== "undefined" && module.exports) {
    module.exports = tinycolor;
}
// AMD/requirejs: Define the module
else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {return tinycolor;}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}
// Browser: Expose to window
else {
    window.tinycolor = tinycolor;
}

})(Math);


/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// background.js